import React, { PropsWithChildren, useEffect } from 'react';

import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps extends PropsWithChildren {
  fallback?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, fallback = <div>Please log in to access this page.</div> }) => {
  const { isAuthenticated, isLoading, login, error } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !error) {
      login();
    }
  }, [isAuthenticated, isLoading, login, error]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Authentication error: {error.message}</div>;
  }

  if (!isAuthenticated) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
